import React from 'react'
// import Pos from 'pages/POS'
import Header from 'pages/POS/components/Header'
import POSTable from 'pages/POS/components/POSTable'

export default function POSManagement() {
  return (
    <div className="">
      <Header posSetting />
      <POSTable />
    </div>
  )
}